import {
	Component,
	Input,
	Output,
	EventEmitter,
	ViewChildren,
	ElementRef,
	QueryList,
} from '@angular/core';
import { ProductMediaItem } from '@app/product/reducers/product.reducer';
import { faAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';

@Component({
	selector: 'g-product-media-viewer',
	templateUrl: './product-media-viewer.component.html',
	styleUrls: ['./product-media-viewer.component.scss'],
})
export class ProductMediaViewerComponent {
	@Input() items: ProductMediaItem[];
	@Input() shownItem = 0;
	@Input() isGridView = false;
	@Output() readonly itemClicked = new EventEmitter<{ index: number; item: ProductMediaItem }>();
	@ViewChildren('selectableItem') selectableItems: QueryList<ElementRef<HTMLDivElement>>;
	icons = { faAngleLeft, faAngleRight };

	selectItem(index: number): void {
		this.shownItem = index;
		this.scrollThumbnailIntoView();
		this.itemClicked.emit({ index, item: this.items[index] });
	}

	selectAdjacent(direction: 1 | -1): void {
		this.selectItem(this.shownItem + direction);
	}

	canSelectAdjacent(direction: 1 | -1): boolean {
		const index = this.shownItem + direction;
		return index >= 0 && index < this.items.length;
	}

	private scrollThumbnailIntoView() {
		const shownItemThumbnailEl = this.selectableItems?.find((_, i) => i === this.shownItem);
		shownItemThumbnailEl?.nativeElement?.scrollIntoView({
			behavior: 'smooth',
			block: 'end',
			inline: 'center',
		});
	}
}
